import { styled } from '@mui/material/styles';


const RootStyle = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    padding: '48px 0px 48px 0px'
}));

export default function Header(props) {
    return(
        <RootStyle>
            <img src={process.env.PUBLIC_URL+"/static/logo.png"} alt='logo' />
            { props.subtitle ? <div>{props.subtitle}</div> : null }
        </RootStyle>
    )
}